// DEPENDENCIES
import React from "react";
// COMPONENTS
import { Link } from "react-router-dom";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../_helpers";
// ASSETS
import Logo from '../../../../assets/img/aes-logo-white.png';

export function Brand() {
  return (
    <>
      <div
        className={`aside-brand d-flex flex-column align-items-center flex-column-auto py-5 py-lg-12`}
      >
        <Link to="" className="brand-logo">
          <img
            alt="logo"
            src={toAbsoluteUrl(Logo)}
            className="max-h-40px"
          />
        </Link>
      </div>
    </>
  );
}
